import React , {useState , useEffect} from 'react';
import { Row , Col } from 'react-bootstrap';
import Button from '../../components/common/Button/Button';
import './faq.css'
import { showToast } from '../../components/common/ToastNotification/ToastNotification';
import { FaArrowLeftLong } from "react-icons/fa6";
import FormInput from '../../components/common/FormInput/FormInput';
import { useNavigate, useParams } from 'react-router-dom';
import { addFAQ , updateFAQ , getFAQById } from '../../api/service/faq.service';

const AddFaq = () => {
    let { id } = useParams()
    let navigate = useNavigate()
    const [loading , setLoading] = useState(false);
    const [formData, setFormData] = useState({
        question : "",
        answer : "",
    });

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async () => {
        try {
            const data = new FormData();
            data.append("question", formData.question);
            data.append("answer", formData.answer);
        
            let response =  await addFAQ(data);
        
            showToast.success(response?.message || "FAQ added successfully!");
        
            navigate("/faq")
            setFormData({
                question : "",
                answer : "",
            });
        } catch (error) {
            console.error("Error adding faq:", error);
            showToast.success(error?.message || "Failed to create FAQ!");
        }
    };

    useEffect(() => {
        const fetchFAQDetails = async () => {
          try {
            const response = await getFAQById(id);
            if (response && response.data) {
              const menu = response.data;
              setFormData({
                question  : menu.question,
                answer : menu.answer || "",
              });
            }
          } catch (error) {
            console.error("Fetch Error:", error);
            showToast.error("Failed to load faq details.");
          } finally {
            
          }
        };
        
        if (id) fetchFAQDetails();
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();
    
        if (!formData.question) {
          showToast.error("Please enter question");
          return;
        }
        
        if (!formData.answer) {
          showToast.error("Please enter answer");
          return;
        }
    
        try {
          setLoading(true);
          const submitData = new FormData();
          submitData.append("faq_id" , id);
          submitData.append("question", formData.question);
          submitData.append("answer", formData.answer);
    
          const response = await updateFAQ(submitData);
          
          if (response.success) {
            showToast.success("FAQ updated successfully!");
            setTimeout(() => {
              navigate("/faq"); 
            }, 1000);
          } else {
            showToast.error(response.message || "Failed to updatefaq");
          }
        } catch (error) {
          console.error("Update Error:", error);
          showToast.error(error.response?.data?.message || "Failed to update faq");
        } finally {
          setLoading(false);
        }
      };
    
    
    return (
        <>
            <div className="d-flex gap-2 align-items-center mb-3">
                <FaArrowLeftLong
                    color="#000"
                    style={{ cursor: "pointer" }}
                    onClick={() => window.history.back()}
                />
                <h3 className="management-tile mb-0 ml-2">{id ? 'Upadte FAQ' : 'Add FAQ'}</h3>
            </div>

            <form onSubmit={id ? handleUpdate : handleSubmit}>
                <Row>
                    <Col xs={12} className="mb-3">
                        <label className="form-label">Question</label>
                        <FormInput 
                            name="question"
                            value={formData.question}
                            placeholder="question"
                            onChange={(e) => handleChange("question", e.target.value)}
                            required
                        />
                    </Col>
                    <Col xs={12} className="mb-3">
                        <label className="form-label">Answer</label>
                        <FormInput 
                            type="textarea"
                            name="answer"
                            value={formData.answer}
                            placeholder="answer"
                            onChange={(e) => handleChange("answer", e.target.value)}
                            required
                        />
                    </Col>
                    <Col xs={12} className="mb-3">
                        <Button onClick={ id ? handleUpdate : handleSubmit}>{id ? 'Update' : 'Add'}</Button>
                    </Col>
                </Row>
            </form>

        </>
    )
}

export default AddFaq